import { render, staticRenderFns } from "./OrderSummationScreen.vue?vue&type=template&id=13a152ac&scoped=true&"
import script from "./OrderSummationScreen.vue?vue&type=script&lang=js&"
export * from "./OrderSummationScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a152ac",
  null
  
)

export default component.exports